<template lang="html">
  <div class="expand-tirocinio" style="width: 95%">
    <div class="">

      <vs-row vs-justify="flex-end" class="m-3 spaced-buttons">
        <vx-tooltip text="Visualizza">
          <vs-button @click="parent.mostraTutor(tr)" class="inline-block" radius color="success" size="small" type="border" icon-pack="feather" icon="icon-eye"/>
        </vx-tooltip>
        <vx-tooltip text="Modifica">
          <vs-button @click="parent.modificaTutor(tr)" class="inline-block" radius color="success" size="small" type="border" icon-pack="feather" icon="icon-edit"/>
        </vx-tooltip>
        <vx-tooltip text="Cambia stato">
          <vs-button @click="parent.cambiaStato(tr)" class="inline-block" radius color="success" size="small" type="border" icon-pack="feather" icon="icon-cloud-lightning"/>
        </vx-tooltip>
      </vs-row>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tr', 'parent'],
  methods: {
    isComplete (stato_i) {
      return stato_i <= this.$tir.index_of(this.tr.stato)
    },
    ultimoCambiamento(stato) {
      return _.reverse(this.tr.stato_history).find(x => x.stato == stato)
    },
    toDate(data) {
      data = this.$utc(data)
      return this.parent.$d(data)
    },
  },
}
</script>

<style lang="css" scoped>
</style>
